import type { ReactNode } from 'react';

export const CheckinPageShell = ({
  children,
  footer,
}: {
  children: ReactNode;
  footer?: ReactNode;
}) => (
  <div className="checkin-page">
    <div className="checkin-page-inner">
      <div className="checkin-page-main">{children}</div>
      {footer}
    </div>
  </div>
);
